
import { CookieService } from 'ngx-cookie-service';
import { User } from '../Models/user';
import { environment } from '../../environments/environment';
import { Ops, SpraEmiRow, SpraRentalAmcvParams, SpraRentalEmiDetail,SpraRentalPL } from '../Models/ops';



export class Utility{
  
   public  user:User = new User();
   public CopMFDSegment:number[] = [1,7];
   constructor(private cookieService:CookieService){
      if(this.cookieService.get("UD") && this.cookieService.get("UD")!=''){
         this.user = JSON.parse(atob(this.cookieService.get("UD")))
       }
      
       
   }
  //Added by rahul yadav on 6/9/2021 for cookie expiry time
public CookieExpiryTime:number=environment.CooKieExpireTime;
//method to reset cookie
public ExtendSessionTime(){
  let CookieSessionId:any;
  let CookieUD:any;
   //store the cookie value in varaibles 
   CookieSessionId = this.cookieService.get('SessionId');
   CookieUD = this.cookieService.get('UD');
   if((CookieUD!=undefined && CookieUD!='') && (CookieSessionId!=undefined && CookieSessionId!='')){
  //Delete the existing cookie value
  this.cookieService.delete('SessionId');
  this.cookieService.delete('UD');
  //Resetting the cookie values
  this.cookieService.set('SessionId', CookieSessionId , this.CookieExpiryTime, undefined, environment.cookieDomain);
  this.cookieService.set('UD', CookieUD , this.CookieExpiryTime, undefined,environment.cookieDomain);
   }else{
      this.RedirectToLogin();
   }
   
}


  public Error(error:any ){
     if(error){      
      if(error.error.text.toLowerCase() == "unauthorizedunauthorized"){
         this.RedirectToLogin();
      }
     }
      
   }

public RedirectToLogin(){
   window.location.href = environment.baseAppUrl;
}


public GetCurrentDate(format?:string):string{
   let today:Date = new Date();
   return this.Getdate(today,format);
   // let dd = String(today.getDate()).padStart(2, '0');
   // let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!   
   // let yyyy = today.getFullYear();  
   // let currentDate = "";
   // if(format == "yyyy/mm/dd"){
   //    currentDate = yyyy + '/' + mm + '/' + dd;
   // }else if(format == "mm/dd/yyyy"){
   //    currentDate = mm + '/' + dd + '/' + yyyy;
   // }else{
   //    currentDate = dd + '/' + mm + '/' + yyyy;
   // }
   // return currentDate;

}


public Getdate(_date:Date,format?:string){
   let dd = String(_date.getDate()).padStart(2, '0');
   let mm = String(_date.getMonth() + 1).padStart(2, '0'); //January is 0!   
   let yyyy = _date.getFullYear();
   if(format == "yyyy/mm/dd"){
     return  yyyy + '/' + mm + '/' + dd;
   }else if(format == "mm/dd/yyyy"){
      return  mm + '/' + dd + '/' + yyyy;
   }else{
      return  dd + '/' + mm + '/' + yyyy;
   }
   
}
//Added by rahul yadav on 25/06/2021 to get date formt from datepicker
public GetdatePickerDate(value:any){
   let ddd : string=""
  let  mmm : string=""
  let date :string="";
  if(value.day < 10 || value.month < 10){
   if(value.day < 10 && value.month >= 10){
      ddd = "0"+value.day;
      date=  ddd + '/' + value.month + '/' + value.year;
   }
    if(value.month < 10 && value.day >= 10){
      mmm ="0"+value.month;
      date=  value.day + '/' + mmm+ '/' + value.year;
   }
    if(value.day < 10 && value.month < 10){
      ddd = "0"+value.day;
      mmm ="0"+value.month;
      date=  ddd + '/' + mmm+ '/' + value.year;
   }
  }
  else{
   date=  value.day + '/' + value.month+ '/' + value.year;
  }
  return date;

}


AddDays(date: Date, days: number,format?:string) {
   if (format == "ForApi"){
      return new Date(date.setDate(date.getDate() + days)).toISOString();
   }else{
      return this.Getdate(new Date(date.setDate(date.getDate() + days)),format);   
   }
   
 }


public CheckStringRequired(value: any): boolean {
   //Added by rahul yadav on 17/06/2021 in case of empty value with space
          if(typeof value == 'string'){
             value = String(value).trim();
          }
         if (value == undefined || value == "") {
            return false;
         } else {
            return true;
         }
     
   }

   public CheckNumberRequired(value: any): boolean {
      if (value== null || value == undefined || value <= 0 ) {
         return false;
      } else {
         return true;
      }
   }

   public CheckNumberRequiredWithZero(value: any): boolean {
      if (value== null || value == undefined || value < 0 ) {
         return false;
      } else {
         return true;
      }
   }

   
   public CheckValidNumber(value: any): boolean {
      if (typeof(value) != 'number') {
         return false;
      } else {
         return true;
      }
   }



   Ordinal_suffix_of(i:number) {
      var j = i % 10,
          k = i % 100;
      if (j == 1 && k != 11) {
          return i + "st";
      }
      if (j == 2 && k != 12) {
          return i + "nd";
      }
      if (j == 3 && k != 13) {
          return i + "rd";
      }
      return i + "th";
  }


ClearCookies(cookieName:string){
   this.cookieService.delete(cookieName);
}
ClearAllCookies(){
   this.cookieService.deleteAll();
}

LogOutErp(){
   window.location.href = environment.baseAppUrl + "logout.aspx"
}



CreateEmiChart(spraRentalEmiDetail:SpraRentalEmiDetail){

   if(spraRentalEmiDetail.LockInMonths>0){
      spraRentalEmiDetail.SpraEmiChart = [];
     let i:number;
     for(i=0;i<spraRentalEmiDetail.LockInMonths;i++){
       let spraEmiRow:SpraEmiRow =  new SpraEmiRow();
       if(i==0){
         spraEmiRow.Opening = spraRentalEmiDetail.LoanAmount
       }else{
         spraEmiRow.Opening = spraRentalEmiDetail.SpraEmiChart[i-1].Closing;
       }
       spraEmiRow.Months = (i+1);
       spraEmiRow.Interest = parseFloat(((spraEmiRow.Opening*spraRentalEmiDetail.RateOfInterest)/(100*12)).toFixed(0));
       if (spraRentalEmiDetail.FreeCopyValue>0){

         spraEmiRow.Principal = spraRentalEmiDetail.FreeCopyValue;
         spraEmiRow.PrincipalMC = parseFloat((spraRentalEmiDetail.EMI - spraEmiRow.Interest).toFixed(0)) - spraEmiRow.Principal;
         spraEmiRow.Closing = parseFloat((spraEmiRow.Opening - spraEmiRow.Principal-spraEmiRow.PrincipalMC).toFixed(0));

       }else{
         spraEmiRow.Principal = parseFloat((spraRentalEmiDetail.EMI - spraEmiRow.Interest).toFixed(0));
         spraEmiRow.Closing = parseFloat((spraEmiRow.Opening - spraEmiRow.Principal).toFixed(0));
       }
       spraRentalEmiDetail.SpraEmiChart.push(spraEmiRow);
     }

   }


 }



 CalculateLoanAmount(spraRentalEmiDetail:SpraRentalEmiDetail){
   spraRentalEmiDetail.LoanAmount =  this.PV(spraRentalEmiDetail.RateOfInterest,spraRentalEmiDetail.LockInMonths,spraRentalEmiDetail.EMI);
 }



PV(rate:number, nper:number, pmt:number)
{
   rate = (1*rate/100/12);
    return parseFloat((pmt / rate * (1 - Math.pow(1 + rate, -nper))).toFixed(0));
}


RoundOff(value:number,roundOff:number=2):number{
  return parseFloat(value.toFixed(roundOff));
}


// FileSize -->> In Bytes ,ValidSize -->> In MB
IsFileSizeValid(FileSize:number,ValidSize:number = 2){
   return (FileSize*0.000001 <=ValidSize)
}


IsFileTypeValid(FileType:string,ValidTypes:string[] = ["application/pdf"]){
   return (ValidTypes.indexOf(FileType)>=0)
}


// commented by rajan singh  on 25 june -->> as found two functions for same calculation - one in utility and one in Ops.ts

// //added by swati on 19/05/2021 to calculate profit percentage
// GetRentalPLPercentage(spraRentalPL:SpraRentalPL,CounterDetail:Array<SpraRentalAmcvParams>)
// {
//    let i:number;
//    let j:number;
//    i=0;
//    j=spraRentalPL.PLMachineLife;
//    spraRentalPL.NoOfYears=[];
   
//    while(j>=12)
//    {
//       spraRentalPL.NoOfYears.push(12);
//        j=j-12;
//    }
//    if((j<12) && (j!=0))
//   {
//    spraRentalPL.NoOfYears.push(j);
//   }
//   spraRentalPL.TotExpenses=0;
//   CounterDetail.forEach((cd) => {
//    spraRentalPL.YearCSARevnue = spraRentalPL.YearCSARevnue + ((cd.CustomerCommitmentCopy+ cd.EMCL)*cd.AgreedCSARate)
//    spraRentalPL.CSACostFreeCopies = spraRentalPL.CSACostFreeCopies + ( cd.AgreedFreeCopy* cd.CSACostRate )
//   });


//    // spraRentalPL.YearCSARevnue = ((spraRentalPL.CustCommitCopyPerMonthBW + spraRentalPL.EstMinimumCopyPerMonthBW)* spraRentalPL.AgreedCSARateBW)
//    //   + ((spraRentalPL.CustCommitCopyPerMonthColor + spraRentalPL.EstMinimumCopyPerMonthColor)* spraRentalPL.AgreedCSARateColor);  

//    //   spraRentalPL.CSACostFreeCopies = ((spraRentalPL.AgreedFreeCopyBW)* spraRentalPL.CSACostRateBW)
//    //   + ((spraRentalPL.AgreedCSARateColor)* spraRentalPL.CSACostRateColor);  
  
//      spraRentalPL.DepreciationVal= (spraRentalPL.TotalCostAmount-spraRentalPL.ResidualValue)/spraRentalPL.PLLockInMonth;
//      spraRentalPL.InsuranceVal = (spraRentalPL.DepreciationVal * spraRentalPL.InsPerc)/100;
//      spraRentalPL.BadDebtVal = (spraRentalPL.DepreciationVal * spraRentalPL.BadDebtPerc)/100;

//      spraRentalPL.TotalRevnue=spraRentalPL.YearCSARevnue + spraRentalPL.MonthlyRent;
//      spraRentalPL.CollChargesVal =  (spraRentalPL.TotalRevnue * spraRentalPL.CollChargesPerc)/100;

//      if(spraRentalPL.CSACostLanded == undefined && spraRentalPL.CSACostLanded == NaN)
//      {
//       spraRentalPL.CSACostLanded=0;
//      }
//      if(spraRentalPL.CSACostFreeCopies == undefined && spraRentalPL.CSACostFreeCopies == NaN)
//      {
//       spraRentalPL.CSACostFreeCopies=0;
//      }
//      if(spraRentalPL.DepreciationVal == undefined && spraRentalPL.DepreciationVal == NaN)
//      {
//       spraRentalPL.DepreciationVal=0;
//      }
//      if(spraRentalPL.InsuranceVal == undefined && spraRentalPL.InsuranceVal == NaN)
//      {
//       spraRentalPL.InsuranceVal=0;
//      }
//      spraRentalPL.TotExpenses= spraRentalPL.CSACostLanded+ spraRentalPL.CSACostFreeCopies+ spraRentalPL.DepreciationVal+ spraRentalPL.InsuranceVal +spraRentalPL.BadDebtVal+spraRentalPL.CollChargesVal ;
   
   
//        let TotRev :number;
//      let SumYearlyCSARevenue :number;
//      let SumRentalRev :number;
//      let TotRevenue :number;
//      SumYearlyCSARevenue=0;
//      SumRentalRev=0;
//      TotRevenue=0;
//      spraRentalPL.SumProfitWithInt=0;
//      spraRentalPL.SumProfitWithoutInt=0;
//      spraRentalPL.NoOfYears.forEach((element: any,index:number) => {  
//          SumYearlyCSARevenue = SumYearlyCSARevenue  + (spraRentalPL.YearCSARevnue* element);
//          SumRentalRev = SumRentalRev + (spraRentalPL.MonthlyRent * element);
//          TotRev= (spraRentalPL.YearCSARevnue* element) + (spraRentalPL.MonthlyRent* element);  

//          let profitWithoutInt:number=((TotRev) - ((spraRentalPL.TotExpenses * element) +spraRentalPL.InterestCostForPL[index]));
//          spraRentalPL.SumProfitWithoutInt = spraRentalPL.SumProfitWithoutInt + profitWithoutInt;
         
//          let profitWithInt:number = profitWithoutInt + spraRentalPL.InterestCostForPL[index];
//          spraRentalPL.SumProfitWithInt = spraRentalPL.SumProfitWithInt + profitWithInt; 
//        });
//        TotRevenue =  SumYearlyCSARevenue + SumRentalRev;
//        spraRentalPL.SumProfitWithoutIntPerc = ( spraRentalPL.SumProfitWithoutInt/ TotRevenue )*100;
//        spraRentalPL.SumProfitWithIntPerc = ( spraRentalPL.SumProfitWithInt/ TotRevenue )*100;
      
// }




downloadExcel(data: any) {   
   const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
   const url= window.URL.createObjectURL(blob);
   window.open(url);
}

}